module.exports = __webpack_public_path__ + "static/media/Banner-promo-Rayados-B.e429b521.png";